<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">{{ added ? 'Create New Media' : 'Edit Media' }}</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-8 is-offset-2">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes, errors }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Title"
                            rules="required"
                          >
                            <b-field
                              label="Title"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.title" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Description"
                            rules="required"
                          >
                            <b-field
                              label="Synopsis / Description"
                              :type="{ 'is-danger': errors.length > 0 || (item.description && item.description.length > 180) }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="item.description"
                                type="textarea"
                                maxlength="500"
                              />
                            </b-field>
                            <p :class="['help', { 'is-danger': item.description && item.description.length > 180 }]">
                              {{ item.description ? item.description.length : 0 }} / 180 characters
                              <span v-if="item.description && item.description.length > 180" class="has-text-weight-bold">
                                (EPG limit exceeded - please shorten)
                              </span>
                            </p>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Tag line"
                          >
                            <b-field
                              label="Tag line"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.tagline" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Media Type"
                            rules="required"
                          >
                            <b-field
                              label="Media Type"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-select
                                v-model="item.mediaType"
                                placeholder="Select a type"
                                expanded
                                @input="addTopLevelGenre(item.mediaType)"
                              >
                                <option value=""></option>
                                <option value="series"
                                  >Series (Episodic Content)</option
                                >
                                <option value="movies">Movie</option>
                                <option value="tvc">TVC (TV Commercial)</option>
                                <option value="filler"
                                  >Filler (Bumpers, Station IDs)</option
                                >
                                <option value="gfx"
                                  >GFX (Graphics, Idents)</option
                                >
                                <option value="promo"
                                  >Promo (Promotional Content)</option
                                >
                              </b-select>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Release Date"
                          >
                            <b-field label="Release Date">
                              <b-datepicker
                                v-model="item.releaseDate"
                                placeholder="Click to select..."
                                icon="calendar-today"
                              >
                              </b-datepicker>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                              item.mediaType === 'tvc' ||
                              item.mediaType === 'filler' ||
                              item.mediaType === 'promo' ||
                              item.mediaType === 'gfx'
                                ? 'Length in Seconds'
                                : 'Length in Minutes'
                            "
                            rules="required"
                          >
                            <b-field
                              :label="
                                item.mediaType === 'tvc' ||
                                item.mediaType === 'filler' ||
                                item.mediaType === 'promo' ||
                                item.mediaType === 'gfx'
                                  ? 'Length in Seconds *'
                                  : item.mediaType === 'movies'
                                  ? 'Length in Minutes *'
                                  : 'Standard Episode Length (Minutes) *'
                              "
                            >
                              <b-input
                                v-model="item.mediaLength"
                                type="number"
                              />
                            </b-field>
                            <p
                              v-if="
                                item.mediaType === 'tvc' ||
                                  item.mediaType === 'filler' ||
                                  item.mediaType === 'promo' ||
                                  item.mediaType === 'gfx'
                              "
                              class="help"
                            >
                              Enter duration in seconds (e.g., 30 for a
                              30-second commercial, 5 for station ID)
                            </p>
                            <p v-else class="help">
                              Enter duration in minutes
                            </p>
                          </ValidationProvider>
                          <ValidationProvider
                            v-if="item.mediaType === 'series'"
                            v-slot="{ errors }"
                            name="Series No"
                          >
                            <b-field label="Series No">
                              <b-input v-model="item.seriesNo" type="number" />
                            </b-field>
                          </ValidationProvider>
                          <ValidationProvider
                            v-if="item.mediaType === 'series'"
                            v-slot="{ errors }"
                            name="No of Episodes"
                          >
                            <b-field label="No of Episodes">
                              <b-input
                                v-model="item.noOfEpisodes"
                                type="number"
                              />
                            </b-field>
                          </ValidationProvider>
                          <ValidationProvider
                            v-if="item.mediaType === 'series'"
                            v-slot="{ errors }"
                            name="Segment Gap"
                          >
                            <b-field label="Segment Gap (seconds)">
                              <b-select
                                v-model="item.segmentGapSeconds"
                                expanded
                              >
                                <option :value="0">None (0s) - Stream copy, fastest</option>
                                <option :value="1">1 second</option>
                                <option :value="2">2 seconds</option>
                                <option :value="3">3 seconds</option>
                                <option :value="5">5 seconds</option>
                              </b-select>
                            </b-field>
                            <p class="help">
                              Black video gaps between segments for commercial breaks. Gap codec will match source files automatically.
                            </p>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Content Type"
                            rules="required"
                          >
                            <b-field
                              label="Content Type"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.types"
                                icon="label"
                                placeholder="Select a top-level genre"
                                autocomplete
                                :data="filteredTypes"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredTypes"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="isGenreRequired ? 'required' : ''"
                            name="Genre"
                          >
                            <b-field
                              :label="
                                isGenreRequired ? 'Genre' : 'Genre (Optional)'
                              "
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.genres"
                                icon="label"
                                placeholder="Select a genre"
                                autocomplete
                                :data="filteredGenres"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredGenres"
                                @remove="onGenreRemove"
                                @focus="onGenreFocus"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Age Restriction"
                          >
                            <b-field
                              label="Age Restriction"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.ageRestriction" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Cast">
                            <b-field
                              label="Cast"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.actors"
                                icon="label"
                                placeholder="Select an cast member"
                                autocomplete
                                :data="filteredActors"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredActors"
                                @add="addActor"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Directors"
                          >
                            <b-field
                              label="Directors"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.directors"
                                icon="label"
                                placeholder="Select a director"
                                autocomplete
                                :data="filteredDirectors"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredDirectors"
                                @add="addDirector"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Languages"
                            rules="required"
                          >
                            <b-field
                              label="Languages *"
                              :type="{
                                'is-danger':
                                  errors.length > 0 ||
                                  item.languages.length === 0
                              }"
                              :message="
                                errors[0] ||
                                  (item.languages.length === 0
                                    ? 'Language is required for TX filename generation'
                                    : '')
                              "
                            >
                              <b-taginput
                                v-model="item.languages"
                                icon="label"
                                placeholder="Select a language"
                                autocomplete
                                :data="filteredLanguages"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredLanguages"
                                @add="addLanguage"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Owner"
                          >
                            <b-field
                              label="Rights Owner"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.rightsOwner" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Distribution Rights"
                          >
                            <b-field
                              label="Distribution Rights"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.rights"
                                icon="label"
                                placeholder="Select rights"
                                autocomplete
                                :data="filteredRights"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredRights"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Distribution Methods"
                          >
                            <b-field
                              label="Distribution Methods"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <div class="columns">
                                <div class="column is-10">
                                  <b-taginput
                                    v-model="item.distributions"
                                    icon="label"
                                    placeholder="Select distribution methods"
                                    autocomplete
                                    :data="filteredDistributions"
                                    field="value"
                                    :open-on-focus="true"
                                    @typing="getFilteredDistributions"
                                  >
                                  </b-taginput>
                                </div>
                                <div class="column is-2">
                                  <b-button
                                    type="is-primary"
                                    @click="addAllDistributions"
                                    >All</b-button
                                  >
                                </div>
                              </div>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Countries"
                          >
                            <b-field
                              label="Rights Countries"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.countries"
                                icon="label"
                                placeholder="Select a country"
                                autocomplete
                                :data="filteredCountries"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredCountries"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Rights Excluded Countries"
                          >
                            <b-field
                              label="Rights Excluded Countries"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.excludedcountries"
                                icon="label"
                                placeholder="Select a country"
                                autocomplete
                                :data="filteredExcludedCountries"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredExcludedCountries"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Supplier"
                            :rules="isSupplierRequired ? 'required' : ''"
                          >
                            <b-field
                              :label="
                                isSupplierRequired
                                  ? 'Supplier *'
                                  : 'Supplier (Optional)'
                              "
                              :type="{
                                'is-danger':
                                  errors.length > 0 ||
                                  (isSupplierRequired &&
                                    item.suppliers.length === 0)
                              }"
                              :message="
                                errors[0] ||
                                  (isSupplierRequired &&
                                  item.suppliers.length === 0
                                    ? 'Supplier is required for TX filename generation'
                                    : '')
                              "
                            >
                              <b-taginput
                                v-model="item.suppliers"
                                :maxtags="1"
                                icon="label"
                                placeholder="Select a supplier"
                                autocomplete
                                :data="filteredSuppliers"
                                field="value"
                                :open-on-focus="true"
                                :allow-new="true"
                                @typing="getFilteredSuppliers"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Channels"
                          >
                            <b-field
                              label="Channels"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.channels"
                                icon="label"
                                placeholder="Select a channel"
                                autocomplete
                                :data="filteredChannels"
                                field="name"
                                :open-on-focus="true"
                                @typing="getFilteredChannels"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <!-- Per-Channel VOD Configuration (shown when channels are selected) -->
                      <div v-if="item.channels && item.channels.length > 0" class="column is-12">
                        <b-field label="VOD Per Channel Override">
                          <div class="box" style="padding: 1rem;">
                            <p class="is-size-7 has-text-grey mb-3">
                              Override VOD settings for this title on specific channels. Select "Channel Default" to use the channel's default VOD setting.
                            </p>
                            <div class="columns is-multiline is-variable is-6">
                              <div
                                v-for="channel in item.channels"
                                :key="channel.id"
                                class="column is-4-desktop is-6-tablet is-12-mobile"
                                style="padding-bottom: 1rem;"
                              >
                                <b-field :label="channel.name" label-position="on-border" class="mb-3">
                                  <b-select
                                    v-model="channel.vodEnabled"
                                    size="is-small"
                                    expanded
                                  >
                                    <option :value="null">Channel Default</option>
                                    <option :value="true">VOD Enabled</option>
                                    <option :value="false">VOD Disabled</option>
                                  </b-select>
                                </b-field>
                              </div>
                            </div>
                          </div>
                        </b-field>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Audio">
                            <b-field
                              label="Audio"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.audios"
                                icon="label"
                                placeholder="Select an audio option"
                                autocomplete
                                :data="filteredAudios"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredAudios"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Resolutions"
                            rules="required"
                          >
                            <b-field
                              label="Resolutions *"
                              :type="{
                                'is-danger':
                                  errors.length > 0 ||
                                  item.resolutions.length === 0
                              }"
                              :message="
                                errors[0] ||
                                  (item.resolutions.length === 0
                                    ? 'Resolution is required for TX filename generation'
                                    : '')
                              "
                            >
                              <b-taginput
                                v-model="item.resolutions"
                                icon="label"
                                placeholder="Select a resolution"
                                autocomplete
                                :data="filteredResolutions"
                                field="value"
                                :open-on-focus="true"
                                @typing="getFilteredResolutions"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider v-slot="{ errors }" name="Tags">
                            <b-field
                              label="Tags"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.tags"
                                icon="label"
                                placeholder="Select tags"
                                autocomplete
                                :data="filteredTags"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredTags"
                                @add="addTag"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Hashtags"
                          >
                            <b-field
                              label="Hashtags"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-taginput
                                v-model="item.hashtags"
                                icon="label"
                                placeholder="Select hashtags"
                                autocomplete
                                :data="filteredHashtags"
                                field="value"
                                :allow-new="true"
                                :open-on-focus="true"
                                @typing="getFilteredHashtags"
                                @add="addHashtag"
                              >
                              </b-taginput>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <!-- Media Player for non-series content -->
                      <div
                        v-if="
                          item.mediaType !== 'series' &&
                            item.storagePath &&
                            !added
                        "
                        class="column is-12"
                      >
                        <b-field label="Media Preview">
                          <MediaPlayer
                            ref="mediaPlayer"
                            :storage-path="item.storagePath"
                            :source-filename="item.sourceFilename"
                            :media-title="item.title"
                            :autoplay="false"
                            :show-info="true"
                          />
                        </b-field>
                      </div>
                      <!-- TX File Status Section for non-episodic content -->
                      <div
                        v-if="!added && item.mediaType !== 'series'"
                        class="column is-12"
                      >
                        <hr
                          style="margin: 20px 0; border-top: 2px solid #dbdbdb;"
                        />
                        <div class="columns">
                          <div class="column is-6-desktop">
                            <h3
                              class="subtitle is-5"
                              style="margin-bottom: 15px;"
                            >
                              <span class="icon">
                                <i class="mdi mdi-file-video"></i>
                              </span>
                              TX File Status
                            </h3>
                          </div>
                          <div class="column is-6-desktop">
                            <div class="tx-status-display has-text-right">
                              <b-field label="Current Status" horizontal>
                                <div class="control">
                                  <b-tag :type="getTxFileStatusType()" size="is-medium">
                                    {{ getTxFileStatusLabel() }}
                                  </b-tag>
                                </div>
                              </b-field>
                              <p class="help">
                                Status based on TX file availability and QC result
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Approve for Playout (non-series shortform only) -->
                        <div
                          v-if="!added && item.mediaType !== 'series' && item.storagePath"
                          class="columns is-vcentered approval-row"
                          style="margin-top: 10px; padding-top: 12px; border-top: 1px solid #ededed;"
                        >
                          <div class="column is-6-desktop">
                            <h4 class="subtitle is-6" style="margin-bottom: 0;">
                              <span class="icon"><i class="mdi mdi-check-decagram"></i></span>
                              Approve for Playout
                            </h4>
                            <p class="help">
                              Final human gate before file is staged to Cinegy. Requires QC pass.
                            </p>
                          </div>
                          <div class="column is-6-desktop has-text-right">
                            <b-tooltip
                              :label="approvalDisabledReason"
                              :active="!canApproveForPlayout"
                              type="is-dark"
                              position="is-left"
                            >
                              <b-switch
                                v-model="item.approvedForPlayout"
                                :disabled="!canApproveForPlayout"
                                type="is-success"
                                size="is-medium"
                                @input="onApprovedForPlayoutToggle"
                              >
                                {{ item.approvedForPlayout ? 'Approved' : 'Not approved' }}
                              </b-switch>
                            </b-tooltip>
                            <p
                              v-if="item.approvedForPlayout && item.approvedForPlayoutBy"
                              class="help has-text-right"
                            >
                              By {{ item.approvedForPlayoutBy }}{{ item.approvedForPlayoutAt ? ' on ' + formatApprovalDate(item.approvedForPlayoutAt) : '' }}
                            </p>
                            <p
                              v-if="item.smbStagingStatus && item.smbStagingStatus !== 'not_staged'"
                              class="help has-text-right"
                              :class="smbStagingHelpClass"
                            >
                              Staging: {{ item.smbStagingStatus }}{{ item.smbStagedAt ? ' (' + formatApprovalDate(item.smbStagedAt) + ')' : '' }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Link Source File and QC for non-episodic content only -->
                      <div
                        v-if="!added && item.mediaType !== 'series'"
                        class="column is-12"
                      >
                        <h3
                          class="subtitle is-5"
                          style="margin-bottom: 15px;"
                        >
                          <span class="icon">
                            <i class="mdi mdi-link-variant"></i>
                          </span>
                          Source File & QC
                        </h3>
                        <div class="control">
                          <MediaSourceLinker
                            :media-id="item.id"
                            :source-filename="item.sourceFilename"
                            :storage-path="item.storagePath"
                            :media-type="item.mediaType"
                            @file-linked="onFileLinked"
                            @file-unlinked="onFileUnlinked"
                            @qc-submitted="onQcSubmitted"
                          />
                        </div>
                      </div>

                      <!-- Upload TX File for non-episodic content only -->
                      <div
                        v-if="!added && item.mediaType !== 'series'"
                        class="column is-12"
                      >
                        <div class="control">
                          <UploadMediaAssets
                            :media-id="item.id"
                            :tx-filename="item.txFilename"
                            @upload-complete="onUploadComplete"
                          ></UploadMediaAssets>
                        </div>
                      </div>

                      <!-- Flightcode Field (TVC and PROMO types only) -->
                      <template
                        v-if="
                          item.mediaType === 'tvc' || item.mediaType === 'promo'
                        "
                      >
                        <div class="column is-12">
                          <hr
                            style="margin: 20px 0; border-top: 2px solid #dbdbdb;"
                          />
                          <h3
                            class="subtitle is-5"
                            style="margin-bottom: 15px;"
                          >
                            <span class="icon">
                              <i class="mdi mdi-tag"></i>
                            </span>
                            Flight Tracking
                          </h3>
                        </div>

                        <div class="column is-6-desktop">
                          <div class="control">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Flightcode"
                            >
                              <b-field
                                label="Flightcode"
                                :type="{ 'is-danger': errors.length > 0 }"
                                :message="errors[0]"
                              >
                                <b-input
                                  v-model="item.flightcode"
                                  placeholder="FLIGHT123"
                                  icon="tag"
                                  maxlength="20"
                                />
                              </b-field>
                            </ValidationProvider>
                            <p class="help">
                              Flight tracking code for
                              {{
                                item.mediaType === 'tvc'
                                  ? 'commercial'
                                  : 'promo'
                              }}
                              campaigns. Will be appended to TX filename as
                              -{flightcode} (dash, not underscore).
                              <br />
                              <strong>Example:</strong>
                              TX_123_Supplier_CocaCola_HD_EN_PG<strong>-FLIGHT123</strong>.mp4
                            </p>
                          </div>
                        </div>
                      </template>

                      <!-- VOD Configuration Section -->
                      <div class="column is-12">
                        <hr
                          style="margin: 20px 0; border-top: 2px solid #dbdbdb;"
                        />
                        <h3 class="subtitle is-5" style="margin-bottom: 15px;">
                          <span class="icon">
                            <i class="mdi mdi-movie-open-play"></i>
                          </span>
                          VOD Configuration
                        </h3>
                      </div>

                      <!-- Per-Channel VOD Configuration (when channels are selected) -->
                      <template v-if="item.channels && item.channels.length > 0">
                        <div class="column is-12">
                          <div class="box" style="background: #f8f9fa;">
                            <div class="columns is-multiline">
                              <div class="column is-12">
                                <b-field label="Configure VOD for Channel">
                                  <b-select
                                    v-model="selectedVodChannelId"
                                    placeholder="Select a channel to configure"
                                    expanded
                                  >
                                    <option :value="null">-- Select Channel --</option>
                                    <option
                                      v-for="channel in item.channels"
                                      :key="channel.id"
                                      :value="channel.id"
                                    >
                                      {{ channel.name }}
                                      {{ channel.vodEnabled === true ? '(VOD Enabled)' : channel.vodEnabled === false ? '(VOD Disabled)' : '(Inherit)' }}
                                    </option>
                                  </b-select>
                                </b-field>
                              </div>

                              <!-- Per-Channel VOD Settings (shown when a channel is selected) -->
                              <template v-if="selectedVodChannel">
                                <div class="column is-3">
                                  <div class="control">
                                    <b-field label="VOD Enabled">
                                      <b-select v-model="selectedVodChannel.vodEnabled" expanded>
                                        <option :value="null">Inherit from Channel Default</option>
                                        <option :value="true">Yes - Enable VOD</option>
                                        <option :value="false">No - Disable VOD</option>
                                      </b-select>
                                    </b-field>
                                  </div>
                                </div>

                                <div class="column is-3">
                                  <div class="control">
                                    <b-field label="VOD Start Offset (minutes)">
                                      <b-input
                                        v-model.number="selectedVodChannel.vodStartOffsetMinutes"
                                        type="number"
                                        min="0"
                                        max="1440"
                                        placeholder="Inherit"
                                      />
                                    </b-field>
                                    <p class="help">
                                      Minutes after TX time
                                    </p>
                                  </div>
                                </div>

                                <div class="column is-3">
                                  <div class="control">
                                    <b-field label="VOD Expiry Offset (days)">
                                      <b-input
                                        v-model.number="selectedVodChannel.vodExpiryOffsetDays"
                                        type="number"
                                        min="1"
                                        max="365"
                                        placeholder="Inherit"
                                      />
                                    </b-field>
                                    <p class="help">
                                      Days after VOD start
                                    </p>
                                  </div>
                                </div>

                                <div class="column is-3">
                                  <div class="control">
                                    <b-field label="VOD Destination">
                                      <b-select
                                        v-model="selectedVodChannel.vodDeliveryDestinationId"
                                        expanded
                                        placeholder="Inherit"
                                      >
                                        <option :value="null">Inherit from Channel</option>
                                        <option
                                          v-for="dest in vodDestinations"
                                          :key="dest.id"
                                          :value="dest.id"
                                        >
                                          {{ dest.name }}
                                        </option>
                                      </b-select>
                                    </b-field>
                                  </div>
                                </div>

                                <!-- Per-Channel VOD Boxset Mode (for series) -->
                                <template v-if="item.mediaType === 'series'">
                                  <div class="column is-12">
                                    <hr style="margin: 10px 0; border-top: 1px dashed #dbdbdb;" />
                                    <b-field>
                                      <b-switch
                                        v-model="selectedVodChannel.vodBoxsetEnabled"
                                        type="is-info"
                                      >
                                        <strong>VOD Boxset Mode</strong> - All episodes share the same VOD window
                                      </b-switch>
                                    </b-field>
                                    <p class="help">
                                      When enabled, all episodes will have the same VOD start and expiry dates for this channel.
                                    </p>
                                  </div>

                                  <template v-if="selectedVodChannel.vodBoxsetEnabled">
                                    <div class="column is-6">
                                      <BaseDateTimePicker
                                        v-model="selectedVodChannel.vodBoxsetStartDatetime"
                                        label="Boxset VOD Start Date/Time"
                                      />
                                      <p class="help">
                                        When the entire season becomes available for catch-up
                                      </p>
                                    </div>

                                    <div class="column is-6">
                                      <BaseDateTimePicker
                                        v-model="selectedVodChannel.vodBoxsetExpiryDatetime"
                                        :min-datetime="selectedVodChannel.vodBoxsetStartDatetime"
                                        label="Boxset VOD Expiry Date/Time"
                                      />
                                      <p class="help">
                                        When the entire season expires from catch-up
                                      </p>
                                    </div>
                                  </template>
                                </template>
                              </template>

                              <div v-else class="column is-12">
                                <p class="has-text-grey-light is-italic">
                                  Select a channel above to configure its VOD settings
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- Title-Level VOD Configuration (fallback when no channels, or as global default) -->
                      <template v-else>
                        <div class="column is-12">
                          <p class="help" style="margin-bottom: 15px;">
                            Override channel-level VOD defaults for this title. Leave blank to inherit from channel.
                          </p>
                        </div>

                        <div class="column is-3">
                          <div class="control">
                            <b-field label="Override VOD Enabled">
                              <b-select v-model="item.vod_enabled" expanded>
                                <option :value="null">Inherit from Channel</option>
                                <option :value="true">Yes - Enable VOD</option>
                                <option :value="false">No - Disable VOD</option>
                              </b-select>
                            </b-field>
                          </div>
                        </div>

                        <div class="column is-3">
                          <div class="control">
                            <b-field label="VOD Start Offset (minutes)">
                              <b-input
                                v-model.number="item.vod_start_offset_minutes"
                                type="number"
                                min="0"
                                max="1440"
                                placeholder="Inherit"
                              />
                            </b-field>
                            <p class="help">
                              Minutes after TX time (blank = inherit from channel)
                            </p>
                          </div>
                        </div>

                        <div class="column is-3">
                          <div class="control">
                            <b-field label="VOD Expiry Offset (days)">
                              <b-input
                                v-model.number="item.vod_expiry_offset_days"
                                type="number"
                                min="1"
                                max="365"
                                placeholder="Inherit"
                              />
                            </b-field>
                            <p class="help">
                              Days after VOD start (blank = inherit)
                            </p>
                          </div>
                        </div>

                        <div class="column is-3">
                          <div class="control">
                            <b-field label="VOD Destination">
                              <b-select
                                v-model="item.vod_delivery_destination_id"
                                expanded
                                placeholder="Inherit from Channel"
                              >
                                <option :value="null">Inherit from Channel</option>
                                <option
                                  v-for="dest in vodDestinations"
                                  :key="dest.id"
                                  :value="dest.id"
                                >
                                  {{ dest.name }}
                                </option>
                              </b-select>
                            </b-field>
                          </div>
                        </div>

                        <!-- VOD Boxset Mode (for series - all episodes share same VOD window) -->
                        <template v-if="item.mediaType === 'series'">
                          <div class="column is-12">
                            <hr style="margin: 15px 0; border-top: 1px dashed #dbdbdb;" />
                            <b-field>
                              <b-switch
                                v-model="item.vod_boxset_enabled"
                                type="is-info"
                              >
                                <strong>VOD Boxset Mode</strong> - All episodes share the same VOD window
                              </b-switch>
                            </b-field>
                            <p class="help">
                              When enabled, all episodes will have the same VOD start and expiry dates (the entire season drops at once).
                            </p>
                          </div>

                          <template v-if="item.vod_boxset_enabled">
                            <div class="column is-6">
                              <BaseDateTimePicker
                                v-model="item.vod_boxset_start_datetime"
                                label="Boxset VOD Start Date/Time"
                              />
                              <p class="help">
                                When the entire season becomes available for catch-up viewing
                              </p>
                            </div>

                            <div class="column is-6">
                              <BaseDateTimePicker
                                v-model="item.vod_boxset_expiry_datetime"
                                :min-datetime="item.vod_boxset_start_datetime"
                                label="Boxset VOD Expiry Date/Time"
                              />
                              <p class="help">
                                When the entire season expires from catch-up
                              </p>
                            </div>
                          </template>
                        </template>
                      </template>

                      <!-- EPG Configuration Section -->
                      <div class="column is-12">
                        <hr
                          style="margin: 20px 0; border-top: 2px solid #dbdbdb;"
                        />
                        <h3
                          class="subtitle is-5"
                          style="margin-bottom: 15px;"
                        >
                          <span class="icon">
                            <i class="mdi mdi-television-guide"></i>
                          </span>
                          EPG Configuration
                        </h3>
                      </div>

                      <div class="column is-12">
                        <b-field label="Country Blockouts (Override Channel Defaults)">
                          <b-taginput
                            v-model="item.epgBlockouts"
                            :data="filteredBlockoutCountries"
                            autocomplete
                            :allow-new="false"
                            :open-on-focus="true"
                            field="name"
                            icon="earth"
                            placeholder="Leave empty to use channel defaults..."
                            @typing="filterBlockoutCountries"
                          >
                            <template #default="props">
                              <strong>{{ props.option.name }}</strong>
                              <span v-if="props.option.note" class="has-text-grey"> - {{ props.option.note }}</span>
                            </template>
                            <template #empty>
                              No countries found
                            </template>
                          </b-taginput>
                        </b-field>
                        <p class="help">
                          Leave empty to inherit channel defaults. These blockouts apply to all episodes unless overridden at episode level.
                          <br />
                          <strong>Individual countries:</strong> Botswana, Malawi, Mozambique, Namibia, South Africa, Swaziland, Zambia, Zimbabwe, Angola, Ethiopia, Ghana, Kenya, Nigeria, Tanzania, Uganda
                          <br />
                          <strong>Agency:</strong> Blocks all 24 francophone African countries as a group
                        </p>
                      </div>

                      <!-- File Information Section (Non-series types: movies, tvc, filler, gfx, promo) -->
                      <template v-if="!added && item.mediaType !== 'series'">
                        <div class="column is-12">
                          <hr
                            style="margin: 20px 0; border-top: 2px solid #dbdbdb;"
                          />
                          <h3
                            class="subtitle is-5"
                            style="margin-bottom: 15px;"
                          >
                            <span class="icon">
                              <i class="mdi mdi-file-video"></i>
                            </span>
                            File Information
                          </h3>
                        </div>

                        <div class="column is-12">
                          <b-field
                            label="TX Filename (Ideal for Playout)"
                            label-position="on-border"
                            grouped
                          >
                            <b-input
                              v-model="item.txFilename"
                              readonly
                              icon="television"
                              placeholder="Select a channel to generate TX filename"
                              expanded
                            />
                            <p class="control">
                              <b-button
                                type="is-link"
                                icon-left="refresh"
                                :loading="regeneratingTxFilename"
                                @click="regenerateTxFilename"
                              >
                                Regenerate
                              </b-button>
                            </p>
                          </b-field>
                          <p class="help">
                            <span v-if="item.txFilename" class="has-text-success">
                              <b-icon icon="check" size="is-small" />
                              Generated from channel template
                            </span>
                            <span v-else>
                              Select a channel above to auto-generate based on channel template configuration
                            </span>
                          </p>
                        </div>

                        <div class="column is-12">
                          <b-field
                            label="Playout Path (Auto-generated)"
                            label-position="on-border"
                          >
                            <b-input
                              v-model="item.playoutPath"
                              readonly
                              icon="folder-network"
                              placeholder="Not generated yet"
                            />
                          </b-field>
                          <p class="help">
                            Relative path from channel playout root: TX/{{
                              item.mediaType
                                ? item.mediaType.toUpperCase()
                                : 'TYPE'
                            }}/{txFilename}
                            <br />
                            <strong>Note:</strong> Regenerates when metadata
                            (title, rating, language) changes
                          </p>
                        </div>
                      </template>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name:
                              $route.query && $route.query.admin
                                ? 'ManageAllMedia'
                                : 'ManageMedia'
                          }"
                        >
                          Back to List</b-button
                        >
                        <b-button
                          v-if="item.mediaType === 'series'"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageEpisodes',
                            params: { id: item.id }
                          }"
                        >
                          Manage Episodes</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          {{ added ? 'Create' : 'Update' }}
                        </button>
                        <b-button
                          v-if="!added"
                          type="is-warning"
                          size="is-medium"
                          icon-left="history"
                          @click="showRecentChanges"
                        >
                          Recent Changes
                        </b-button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
    <RecentChangesModal
      :show="showRecentChangesModal"
      @refresh="refreshData"
      @close-modal="showRecentChangesModal = false"
    ></RecentChangesModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import UploadMediaAssets from '@/components/UploadMediaAssets'
import UploadImage from '@/components/UploadImage'
import UploadVideo from '@/components/UploadVideo'
import MediaPlayer from '@/components/MediaPlayer'
import MediaSourceLinker from '@/components/MediaSourceLinker'
import MediaApi from '@/api/media'
import ChannelApi from '@/api/channels'
import MediaChannelApi from '@/api/mediaChannels'
import TxIngestApi from '@/api/txIngest'
import RecentChangesModal from '@/components/RecentChangesModal'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'

export default {
  name: 'EditMedia',
  components: {
    CardComponent,
    UploadImage,
    UploadVideo,
    UploadMediaAssets,
    MediaPlayer,
    MediaSourceLinker,
    RecentChangesModal,
    BaseDateTimePicker
  },
  metaInfo: {
    title: 'Edit Title'
  },
  computed: {
    ...mapGetters(['user']),
    // Approval is the HUMAN gate — operator visually verifies the
    // shortform file (a 30-sec promo, a station ID, a filler) and
    // clicks approve. The user identity + timestamp captured server
    // side IS the audit record. Automated QC on the file is optional
    // — when run it informs the operator's decision but does not gate
    // approval. Only requirement: a file must actually be linked.
    canApproveForPlayout () {
      return !!this.item.storagePath
    },
    approvalDisabledReason () {
      if (!this.item.storagePath) return 'No TX file linked yet'
      return ''
    },
    smbStagingHelpClass () {
      const s = this.item.smbStagingStatus
      if (s === 'failed') return 'has-text-danger'
      if (s === 'staged') return 'has-text-success'
      return 'has-text-info'
    },
    // Genre is optional for TVC, GFX, Filler, Promo
    isGenreRequired() {
      return !['tvc', 'gfx', 'filler', 'promo'].includes(this.item.mediaType)
    },
    // Supplier is optional for TVC, GFX, Filler, Promo
    isSupplierRequired() {
      return !['tvc', 'gfx', 'filler', 'promo'].includes(this.item.mediaType)
    },
    // Returns the channel object for per-channel VOD configuration
    selectedVodChannel() {
      if (!this.selectedVodChannelId || !this.item.channels) {
        return null
      }
      return this.item.channels.find(ch => ch.id === this.selectedVodChannelId) || null
    }
  },
  watch: {
    // Watch for supplier selection changes to generate TX filename preview
    // (Channel is matched from supplier name, just like segment auto-generation)
    'item.suppliers': {
      handler(newSuppliers) {
        this.generateTxFilenameFromSupplier()
      },
      deep: true
    },
    // Also regenerate when media type changes
    'item.mediaType'(newType) {
      this.generateTxFilenameFromSupplier()
    },
    // Also regenerate when title changes (after a debounce would be nice but keep it simple)
    'item.title'(newTitle) {
      // Only trigger if we have supplier - avoid unnecessary API calls
      if (this.item.suppliers && this.item.suppliers.length > 0) {
        this.generateTxFilenameFromSupplier()
      }
    },
    // Regenerate when duration changes (non-series templates include {DURATION})
    // Force=true so an already-generated filename gets refreshed with the new duration
    'item.mediaLength'(newLength) {
      const nonSeriesTypes = ['movies', 'tvc', 'filler', 'promo', 'gfx']
      if (nonSeriesTypes.includes(this.item.mediaType) && this.item.suppliers && this.item.suppliers.length > 0) {
        this.generateTxFilenameFromSupplier(true)
      }
    },
    // Watch for Content Type (types) changes to refresh genre options
    // Genres are filtered based on the selected content types via metadata links
    'item.types': {
      handler() {
        this.$nextTick(() => {
          this.getFilteredGenres('')
        })
      },
      deep: true
    }
  },
  async mounted() {
    this.added = this.$route.name === 'CreateMedia' ? true : false
    if (!this.added) {
      this.setData()
      this.initialized = false
    }
    this.links = await MediaApi.getMetadataLinks()
    const lookups = await MediaApi.defaultLookups()
    this.genres = lookups.genre ? lookups.genre : []
    this.getFilteredGenres('')
    this.languages = lookups.language ? lookups.language : []
    this.filteredLanguages = this.languages
    this.countries = lookups.country ? lookups.country : []
    this.filteredCountries = this.countries
    this.excludedcountries = lookups.excludedcountry
      ? lookups.excludedcountry
      : []
    this.filteredExcludedCountries = this.excludedcountries
    this.tags = lookups.tag ? lookups.tag : []
    this.hashtags = lookups.hashtags ? lookups.hashtags : []
    this.filteredTags = this.tags
    this.filteredHashtags = this.hashtags
    this.actors = lookups.actor ? lookups.actor : []
    this.filteredActors = this.actors
    this.directors = lookups.director ? lookups.director : []
    this.filteredDirectors = this.directors
    this.suppliers = lookups.supplier ? lookups.supplier : []
    this.filteredSuppliers = this.suppliers
    this.resolutions = lookups.resolution ? lookups.resolution : []
    this.filteredResolutions = this.resolutions
    this.audios = lookups.audio ? lookups.audio : []
    this.filteredAudios = this.audios
    // Initialize EPG blockout countries filter
    this.filteredBlockoutCountries = this.blockoutCountries
    this.types = lookups.type ? lookups.type : []
    this.filteredTypes = this.types
    this.rights = lookups.right ? lookups.right : []
    this.filteredRights = this.rights
    this.distributions = lookups.distribution ? lookups.distribution : []
    this.getFilteredDistributions('')
    this.channels = await ChannelApi.getAll()
    this.getFilteredChannels('')
    // Load VOD destinations for dropdown
    try {
      const destinations = await TxIngestApi.getVodDestinations()
      this.vodDestinations = destinations || []
    } catch (err) {
      console.warn('Could not load VOD destinations:', err)
      this.vodDestinations = []
    }
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      added: false,
      showRecentChangesModal: false,
      // Per-channel VOD configuration - which channel is selected for config
      selectedVodChannelId: null,
      item: {
        // Initialize all form fields to prevent undefined values
        mediaType: null,
        mediaLength: null,
        title: '',
        description: '',
        // File tracking fields
        sourceFilename: '',
        storagePath: '',
        // QC status fields (for non-series media)
        qcStatus: null,
        qcResultId: null,
        // Playout approval & SMB staging (non-series shortform)
        approvedForPlayout: false,
        approvedForPlayoutAt: null,
        approvedForPlayoutBy: null,
        smbStagingStatus: 'not_staged',
        smbStagedAt: null,
        smbStagedPath: null,
        smbStagingError: null,
        // Segment stitching settings
        segmentGapSeconds: 0,
        // Initialize metadata arrays
        languages: [],
        resolutions: [],
        genres: [],
        suppliers: [],
        types: [],
        actors: [],
        directors: [],
        tags: [],
        hashtags: [],
        audios: [],
        rights: [],
        distributions: [],
        channels: [],
        countries: [],
        excludedcountries: [],
        // VOD Configuration (override channel defaults - null = inherit)
        vod_enabled: null,
        vod_start_offset_minutes: null,
        vod_expiry_offset_days: null,
        vod_delivery_destination_id: null,
        // VOD Boxset Mode - all episodes share same VOD window
        vod_boxset_enabled: false,
        vod_boxset_start_datetime: null,
        vod_boxset_expiry_datetime: null,
        // EPG Configuration
        epgBlockouts: []
      },
      // VOD Destinations (loaded from API)
      vodDestinations: [],
      regeneratingTxFilename: false,
      genres: [],
      countries: [],
      languages: [],
      tags: [],
      hashtags: [],
      actors: [],
      directors: [],
      resolutions: [],
      audio: [],
      suppliers: [],
      types: [],
      rights: [],
      channels: [],
      distributions: [],
      filteredGenres: [],
      filteredLanguages: [],
      filteredCountries: [],
      filteredExcludedCountries: [],
      filteredTags: [],
      filteredHashtags: [],
      filteredActors: [],
      filteredTypes: [],
      filteredRights: [],
      filteredDistributions: [],
      filteredChannels: [],
      filteredDirectors: [],
      filteredResolutions: [],
      filteredAudios: [],
      filteredSuppliers: [],
      links: [],
      // EPG Country Blockouts - All Sub-Saharan African Countries (MultiChoice spec)
      blockoutCountries: [
        // Special group for francophone countries
        { name: 'Agency', note: 'All 24 francophone African countries' },
        // Eastern Africa
        { name: 'Burundi', note: '' },
        { name: 'Comoros', note: '' },
        { name: 'Djibouti', note: '' },
        { name: 'Eritrea', note: '' },
        { name: 'Ethiopia', note: '' },
        { name: 'Kenya', note: '' },
        { name: 'Madagascar', note: '' },
        { name: 'Malawi', note: '' },
        { name: 'Mauritius', note: '' },
        { name: 'Mozambique', note: '' },
        { name: 'Rwanda', note: '' },
        { name: 'Seychelles', note: '' },
        { name: 'Somalia', note: '' },
        { name: 'South Sudan', note: '' },
        { name: 'Tanzania', note: '' },
        { name: 'Uganda', note: '' },
        { name: 'Zambia', note: '' },
        { name: 'Zimbabwe', note: '' },
        // Central Africa
        { name: 'Angola', note: '' },
        { name: 'Cameroon', note: '' },
        { name: 'Central African Republic', note: '' },
        { name: 'Chad', note: '' },
        { name: 'Democratic Republic of the Congo', note: '' },
        { name: 'Equatorial Guinea', note: '' },
        { name: 'Gabon', note: '' },
        { name: 'Republic of the Congo', note: '' },
        { name: 'São Tomé and Príncipe', note: '' },
        // Southern Africa
        { name: 'Botswana', note: '' },
        { name: 'Eswatini', note: 'Formerly Swaziland' },
        { name: 'Lesotho', note: '' },
        { name: 'Namibia', note: '' },
        { name: 'South Africa', note: '' },
        { name: 'Swaziland', note: 'Now Eswatini' },
        // Western Africa
        { name: 'Benin', note: '' },
        { name: 'Burkina Faso', note: '' },
        { name: 'Cape Verde', note: '' },
        { name: 'Côte d\'Ivoire', note: 'Ivory Coast' },
        { name: 'Gambia', note: '' },
        { name: 'Ghana', note: '' },
        { name: 'Guinea', note: '' },
        { name: 'Guinea-Bissau', note: '' },
        { name: 'Liberia', note: '' },
        { name: 'Mali', note: '' },
        { name: 'Mauritania', note: '' },
        { name: 'Niger', note: '' },
        { name: 'Nigeria', note: '' },
        { name: 'Senegal', note: '' },
        { name: 'Sierra Leone', note: '' },
        { name: 'Togo', note: '' }
      ],
      filteredBlockoutCountries: []
    }
  },
  methods: {
    ...mapActions(['getUser']),
    async setData() {
      this.initialized = false
      this.added = false
      let media = await MediaApi.getById(this.$route.params.id)
      if (media) {
        this.item.id = media.id
        this.item.title = media.title
        this.item.description = media.description
        this.item.mediaType = media.media_type
        this.item.published = media.published

        // File tracking fields (for non-series types: movies, tvc, filler, gfx, promo)
        this.item.sourceFilename = media.source_filename || ''
        this.item.storagePath = media.storage_path || ''
        this.item.txFilename = media.tx_filename || ''
        this.item.playoutPath = media.playout_path || ''
        this.item.flightcode = media.flightcode || ''
        // QC status fields
        this.item.qcStatus = media.qc_status || null
        this.item.qcResultId = media.qc_result_id || null
        // Playout approval & SMB staging (non-series shortform only)
        this.item.approvedForPlayout = !!media.approved_for_playout
        this.item.approvedForPlayoutAt = media.approved_for_playout_at || null
        this.item.approvedForPlayoutBy = media.approved_for_playout_by || null
        this.item.smbStagingStatus = media.smb_staging_status || 'not_staged'
        this.item.smbStagedAt = media.smb_staged_at || null
        this.item.smbStagedPath = media.smb_staged_path || null
        this.item.smbStagingError = media.smb_staging_error || null

        // Segment stitching settings
        this.item.segmentGapSeconds = parseFloat(media.segment_gap_seconds) || 0

        if (media.mediadata && media.mediadata !== '') {
          media.mediadata = JSON.parse(media.mediadata)
          if (media.mediadata.releaseDate) {
            this.item.releaseDate = new Date(media.mediadata.releaseDate)
          }
          this.item.mediaLength = media.mediadata.mediaLength
          this.item.tagline = media.mediadata.tagline

          if (this.item.mediaType === 'series') {
            this.item.noOfEpisodes = media.mediadata.noOfEpisodes
            this.item.seriesNo = media.mediadata.seriesNo
          }

          this.item.ageRestriction = media.mediadata.ageRestriction
          this.item.rightsOwner = media.mediadata.rightsOwner

          // EPG Configuration - load blockouts from mediadata
          if (media.mediadata.epgBlockouts && media.mediadata.epgBlockouts.length > 0) {
            // Convert string array to objects for taginput component
            this.item.epgBlockouts = media.mediadata.epgBlockouts.map(name => {
              return this.blockoutCountries.find(c => c.name === name) || { name: name, note: '' }
            })
          } else {
            this.item.epgBlockouts = []
          }
        }
        // Initialize metadata arrays (always set to empty array if no data)
        this.item.genres = []
        this.item.countries = []
        this.item.excludedcountries = []
        this.item.languages = []
        this.item.tags = []
        this.item.hashtags = []
        this.item.actors = []
        this.item.directors = []
        this.item.suppliers = []
        this.item.audios = []
        this.item.resolutions = []
        this.item.types = []
        this.item.rights = []
        this.item.distributions = []
        this.item.channels = []

        if (media.mediaMetadata && media.mediaMetadata.length > 0) {
          this.item.genres = this.setValues(media.mediaMetadata, 'genre')
          this.item.countries = this.setValues(media.mediaMetadata, 'country')
          this.item.excludedcountries = this.setValues(
            media.mediaMetadata,
            'excludedcountry'
          )
          this.item.languages = this.setValues(media.mediaMetadata, 'language')
          this.item.tags = this.setValues(media.mediaMetadata, 'tag')
          this.item.hashtags = this.setValues(media.mediaMetadata, 'hashtag')
          this.item.actors = this.setValues(media.mediaMetadata, 'actor')
          this.item.directors = this.setValues(media.mediaMetadata, 'director')
          this.item.suppliers = this.setValues(media.mediaMetadata, 'supplier')
          this.item.audios = this.setValues(media.mediaMetadata, 'audio')
          this.item.resolutions = this.setValues(
            media.mediaMetadata,
            'resolution'
          )
          this.item.types = this.setValues(media.mediaMetadata, 'type')
          this.item.rights = this.setValues(media.mediaMetadata, 'right')
          this.item.distributions = this.setValues(
            media.mediaMetadata,
            'distribution'
          )
        }

        this.item.channels = await MediaChannelApi.getByMediaId(media.id)

        // VOD Configuration (override channel defaults)
        this.item.vod_enabled = media.vod_enabled ?? null
        this.item.vod_start_offset_minutes = media.vod_start_offset_minutes ?? null
        this.item.vod_expiry_offset_days = media.vod_expiry_offset_days ?? null
        this.item.vod_delivery_destination_id = media.vod_delivery_destination_id || null

        // VOD Boxset Mode
        this.item.vod_boxset_enabled = media.vod_boxset_enabled ?? false
        this.item.vod_boxset_start_datetime = media.vod_boxset_start_datetime
          ? new Date(media.vod_boxset_start_datetime)
          : null
        this.item.vod_boxset_expiry_datetime = media.vod_boxset_expiry_datetime
          ? new Date(media.vod_boxset_expiry_datetime)
          : null
      }
      this.initialized = true
    },
    getValues(list) {
      return list ? list.map(item => (item.value ? item.value : item)) : []
    },
    setValues(list, type) {
      return list
        ? list
            .filter(item => item.metadata_type === type)
            .map(item => ({
              id: item.metadata_id,
              value: item.value,
              metadata_type: type
            }))
        : []
    },
    submit() {
      // Build mediadata object for saving
      const mediadata = {
        mediaLength: this.item.mediaLength,
        tagline: this.item.tagline,
        noOfEpisodes: this.item.noOfEpisodes,
        seriesNo: this.item.seriesNo,
        releaseDate: this.item.releaseDate,
        ageRestriction: this.item.ageRestriction,
        rightsOwner: this.item.rightsOwner
      }
      // Add EPG blockouts if set (convert from objects to string array)
      if (this.item.epgBlockouts && this.item.epgBlockouts.length > 0) {
        mediadata.epgBlockouts = this.item.epgBlockouts.map(c => c.name || c)
      }
      this.item.mediadata = mediadata
      this.item.metadata = {
        genres: this.getValues(this.item.genres),
        languages: this.getValues(this.item.languages),
        countries: this.getValues(this.item.countries),
        excludedcountries: this.getValues(this.item.excludedcountries),
        tags: this.getValues(this.item.tags),
        hashtags: this.getValues(this.item.hashtags),
        actors: this.getValues(this.item.actors),
        types: this.getValues(this.item.types),
        rights: this.getValues(this.item.rights),
        distributions: this.getValues(this.item.distributions),
        directors: this.getValues(this.item.directors),
        suppliers: this.getValues(this.item.suppliers),
        resolutions: this.getValues(this.item.resolutions),
        audios: this.getValues(this.item.audios)
        // NOTE: channels are NOT included here - they are sent as this.item.channels
        // with full objects including vodEnabled, vodStartOffsetMinutes, vodExpiryOffsetDays
      }
      this.loading = true
      if (!this.item.id) {
        MediaApi.create(this.item)
          .then(response => {
            this.$buefy.toast.open({
              message: 'Media created successfully!',
              position: 'is-top',
              type: 'is-success'
            })
            this.$router.push({
              name: 'EditMedia',
              params: { id: response.mediaId }
            })
            this.setData()
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.loading = false

            // Handle duplicate media error
            if (err.data && err.data.err === 'E_DUPLICATE_MEDIA') {
              const existing = err.data.existingMedia
              const seasonInfo = existing.seriesNo ? ` Season ${existing.seriesNo}` : ''
              this.$buefy.dialog.confirm({
                title: 'Duplicate Title',
                message: `A title "${existing.title}"${seasonInfo} already exists.<br><br>Would you like to edit the existing title instead?`,
                confirmText: 'Go to Existing',
                cancelText: 'Cancel',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: () => {
                  this.$router.push({
                    name: 'EditMedia',
                    params: { id: existing.id }
                  })
                }
              })
              return
            }

            this.$buefy.toast.open({
              message: 'Error saving media',
              position: 'is-top',
              type: 'is-danger'
            })
          })
      } else {
        this.item.mediaId = this.item.id
        console.log('[EditMedia.submit] Sending update with channels:', this.item.channels)
        console.log('[EditMedia.submit] Channels count:', this.item.channels?.length)
        if (this.item.channels && this.item.channels.length > 0) {
          console.log('[EditMedia.submit] First channel:', JSON.stringify(this.item.channels[0]))
        }
        MediaApi.update(this.item)
          .then(() => {
            this.$buefy.toast.open({
              message: 'Media updated successfully!',
              position: 'is-top',
              type: 'is-success'
            })
            this.setData()
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$buefy.toast.open({
              message: 'Error saving media',
              position: 'is-top',
              type: 'is-danger'
            })
            this.loading = false
          })
      }
    },
    getFilteredChannels(text) {
      this.filteredChannels = this.channels.filter(option => {
        return option.name.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredMetadata(text, key, filteredKey) {
      this[filteredKey] = this[key].filter(option => {
        return option.value.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredGenres(text) {
      const searchText = (text || '').toLowerCase()

      if (this.item.types && this.item.types.length > 0) {
        // Filter genres based on linked types
        const topLevelGenreIds = this.item.types.map(item => item.id)
        const childIds = this.links
          .filter(item => topLevelGenreIds.includes(item.metadata_id))
          .map(item => item.linked_metadata_id)

        // Try filtering by linked types first
        const linkedGenres = this.genres.filter(option => {
          return (
            childIds.includes(option.id) &&
            option.value.toLowerCase().indexOf(searchText) >= 0
          )
        })

        // If linked filtering returns results, use those
        // Otherwise fallback to all genres (in case links aren't configured)
        if (linkedGenres.length > 0 || childIds.length > 0) {
          this.filteredGenres = linkedGenres
        } else {
          // No links configured for this content type - show all genres
          console.log('No genre links found for content type, showing all genres')
          this.filteredGenres = this.genres.filter(option => {
            return option.value.toLowerCase().indexOf(searchText) >= 0
          })
        }
      } else {
        // No types selected - show all genres
        this.filteredGenres = this.genres.filter(option => {
          return option.value.toLowerCase().indexOf(searchText) >= 0
        })
      }
      return []
    },
    getFilteredLanguages(text) {
      this.getFilteredMetadata(text, 'languages', 'filteredLanguages')
    },
    getFilteredCountries(text) {
      this.getFilteredMetadata(text, 'countries', 'filteredCountries')
    },
    getFilteredExcludedCountries(text) {
      this.getFilteredMetadata(
        text,
        'excludedcountries',
        'filteredExcludedCountries'
      )
    },
    getFilteredTags(text) {
      this.getFilteredMetadata(text, 'tags', 'filteredTags')
    },
    getFilteredHashtags(text) {
      this.getFilteredMetadata(text, 'hashtags', 'filteredHashtags')
    },
    getFilteredActors(text) {
      this.getFilteredMetadata(text, 'actors', 'filteredActors')
    },
    getFilteredDirectors(text) {
      this.getFilteredMetadata(text, 'directors', 'filteredDirectors')
    },
    getFilteredSuppliers(text) {
      this.getFilteredMetadata(text, 'suppliers', 'filteredSuppliers')
    },
    getFilteredResolutions(text) {
      this.getFilteredMetadata(text, 'resolutions', 'filteredResolutions')
    },
    getFilteredAudios(text) {
      this.getFilteredMetadata(text, 'audios', 'filteredAudios')
    },
    getFilteredTypes(text) {
      this.getFilteredMetadata(text, 'types', 'filteredTypes')
    },
    getFilteredRights(text) {
      this.getFilteredMetadata(text, 'rights', 'filteredRights')
    },
    getFilteredDistributions(text) {
      if (this.item.rights && this.item.rights.length > 0) {
        const topLevelRightIds = this.item.rights.map(item => item.id)
        const childIds = this.links
          .filter(item => topLevelRightIds.includes(item.metadata_id))
          .map(item => item.linked_metadata_id)
        this.filteredDistributions = this.distributions.filter(option => {
          return (
            childIds.includes(option.id) &&
            option.value.toLowerCase().indexOf(text.toLowerCase()) >= 0
          )
        })
      }
      return []

      // this.getFilteredMetadata(text, 'distributions', 'filteredDistributions')
    },
    addItem(key, text) {
      if (typeof text === 'string') {
        let existing = this[key].find(
          item => item.value && item.value.toLowerCase() === text.toLowerCase()
        )
        if (existing) {
          this.item[key] = this.item[key].filter(item => item !== text)
        }
      }
    },
    addGenre(text) {
      this.addItem('genres', text)
    },
    /**
     * Handle genre tag removal - refresh filtered genres list
     * This ensures the dropdown shows available options after removing a genre
     */
    onGenreRemove() {
      // Small delay to ensure the v-model has updated
      this.$nextTick(() => {
        this.getFilteredGenres('')
      })
    },
    /**
     * Handle genre field focus - refresh filtered genres list
     * This ensures the dropdown shows available options when clicking into the field
     */
    onGenreFocus() {
      this.getFilteredGenres('')
    },
    /**
     * Filter EPG blockout countries based on search text
     */
    filterBlockoutCountries(text) {
      this.filteredBlockoutCountries = this.blockoutCountries.filter(country => {
        return country.name.toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    },
    addLanguage(text) {
      this.addItem('languages', text)
    },
    addCountry(text) {
      this.addItem('countries', text)
    },
    addTag(text) {
      this.addItem('tags', text)
    },
    addHashtag(text) {
      this.addItem('hashtags', text)
    },
    addActor(text) {
      this.addItem('actors', text)
    },
    addDirector(text) {
      this.addItem('directors', text)
    },
    addSupplier(text) {
      this.addItem('suppliers', text)
    },
    addResolutions(text) {
      this.addItem('resolutions', text)
    },
    addAudios(text) {
      this.addItem('audios', text)
    },
    addType(text) {
      this.addItem('types', text)
    },
    addRight(text) {
      this.addItem('rights', text)
    },
    addDistribution(text) {
      this.addItem('distributions', text)
    },
    addTopLevelGenre(mediatype) {
      let found = null
      const removeItem = mediatype === 'series' ? 'movie' : 'series'
      this.item.types = this.item.types.filter(
        item => item.value.toLowerCase() !== removeItem
      )
      found = this.types.find(item => item.value.toLowerCase() === mediatype)
      if (found) {
        this.item.types.push(found)
      }
    },
    addAllDistributions() {
      const topLevelRightIds = this.item.rights.map(item => item.id)
      const childIds = this.links
        .filter(item => topLevelRightIds.includes(item.metadata_id))
        .map(item => item.linked_metadata_id)
      let distributions = this.distributions.filter(option => {
        return childIds.includes(option.id)
      })
      distributions.forEach(distribution => {
        if (this.item.distributions) {
          let found = this.item.distributions.find(
            item => item.id === distribution.id
          )
          if (!found) {
            this.item.distributions.push(distribution)
          }
        }
      })
    },
    showRecentChanges() {
      this.showRecentChangesModal = true
    },
    async refreshData() {
      await this.setData()
    },
    /**
     * Handle upload complete event from UploadMediaAssets
     * Refreshes media data to show updated file info
     */
    async onUploadComplete(uploadInfo) {
      console.log('Upload complete:', uploadInfo)

      // Refresh media data to show updated storage path and file status
      await this.setData()

      // Show success message with QC job info if available
      if (uploadInfo.qcJobId) {
        this.$buefy.toast.open({
          message: `File uploaded and QC job #${uploadInfo.qcJobId} started`,
          position: 'is-top',
          type: 'is-success',
          duration: 5000
        })
      }
    },

    /**
     * Handle file linked event from MediaSourceLinker
     */
    async onFileLinked(fileInfo) {
      console.log('File linked:', fileInfo)
      // Refresh media data to show updated storage path
      await this.setData()
      // Generate TX filename suggestion if not already set
      // Force generation even for existing media (user just linked a file, they need the filename)
      await this.generateTxFilenameFromSupplier(true)
    },

    /**
     * Handle file unlinked event from MediaSourceLinker
     */
    async onFileUnlinked() {
      console.log('File unlinked')
      // Refresh media data
      await this.setData()
    },

    /**
     * Handle QC submitted event from MediaSourceLinker
     */
    onQcSubmitted(result) {
      console.log('QC job submitted:', result)
      this.$buefy.toast.open({
        message: `QC job submitted for processing`,
        position: 'is-top',
        type: 'is-success',
        duration: 5000
      })
    },

    /**
     * Generate TX filename from supplier (matches channel by supplier name)
     * For non-series media types: movies, tvc, filler, promo, gfx
     *
     * NOTE: Channel is determined by matching SUPPLIER name → CHANNEL name (case-insensitive)
     * This is the same logic used for segment auto-generation in episodes.
     */
    async generateTxFilenameFromSupplier(force = false) {
      // Only generate for non-series media types
      const nonSeriesTypes = ['movies', 'tvc', 'filler', 'promo', 'gfx']
      if (!this.item.mediaType || !nonSeriesTypes.includes(this.item.mediaType)) {
        return
      }

      // Need supplier and title to generate TX filename
      const supplier = this.item.suppliers && this.item.suppliers.length > 0
        ? this.item.suppliers[0].value
        : null

      if (!supplier || !this.item.title) {
        return
      }

      // Don't overwrite if TX filename was already saved (set from database)
      // Unless forced (e.g. when linking a file from storage browser)
      if (this.item.txFilename && !this.added && !force) {
        return
      }

      try {
        // Get resolution from selected metadata
        const resolution = this.item.resolutions && this.item.resolutions.length > 0
          ? this.item.resolutions[0].value
          : null

        // Get language from selected metadata
        const language = this.item.languages && this.item.languages.length > 0
          ? this.item.languages[0].value
          : null

        // Get rating from mediadata
        const rating = this.item.ageRestriction || null

        // Prepare request data - supplier will be used to find matching channel
        const requestData = {
          // No channelId - backend will match supplier name → channel name
          title: this.item.title,
          mediaType: this.item.mediaType,
          supplier,
          resolution,
          language,
          rating,
          flightcode: this.item.flightcode || null,
          mediaLength: this.item.mediaLength || null
        }

        // If editing existing media, include mediaId
        if (this.item.id) {
          requestData.mediaId = this.item.id
        }

        // Call API to generate TX filename preview
        const result = await MediaApi.generateTxFilenamePreview(requestData)

        if (result && result.txFilename) {
          this.item.txFilename = result.txFilename
          console.log(`TX filename generated: ${result.txFilename} (channel: ${result.channelName}, matched via: ${result.channelMatchMethod})`)
        }
      } catch (error) {
        // Log error but don't show to user - supplier may not match any channel
        if (error.response && error.response.status === 400) {
          console.log('TX filename generation: No matching channel found for supplier')
        } else {
          console.error('Error generating TX filename preview:', error)
        }
      }
    },

    /**
     * Regenerate TX filename (force) and save to DB
     */
    async regenerateTxFilename() {
      this.regeneratingTxFilename = true
      try {
        await this.generateTxFilenameFromSupplier(true)

        if (this.item.txFilename && this.item.id) {
          // Save the regenerated filename to the database
          await MediaApi.update({ ...this.item, mediaId: this.item.id })
          this.$buefy.toast.open({
            message: `TX filename regenerated: ${this.item.txFilename}`,
            type: 'is-success',
            duration: 4000
          })
        } else {
          this.$buefy.toast.open({
            message: 'Could not generate TX filename. Check supplier, title, and channel config.',
            type: 'is-warning'
          })
        }
      } catch (error) {
        console.error('Failed to regenerate TX filename:', error)
        this.$buefy.toast.open({
          message: error?.response?.data?.error || 'Failed to regenerate TX filename',
          type: 'is-danger'
        })
      } finally {
        this.regeneratingTxFilename = false
      }
    },

    /**
     * Get TX File status type (color) for tag display
     * Uses same logic as EditEpisode for consistency
     */
    getTxFileStatusType() {
      // Primary question: Is there a TX file assigned?
      const hasTxFile = this.item.storagePath
      const qcStatus = this.item.qcStatus

      // 1. NO TX FILE
      if (!hasTxFile) {
        return 'is-light' // No TX File
      }

      // 2. TX FILE EXISTS - check QC status
      if (qcStatus === 'passed') return 'is-success' // TX Ready
      if (qcStatus === 'passed_with_warnings') return 'is-success' // TX Ready*
      if (qcStatus === 'overridden') return 'is-info' // QC Overridden
      if (qcStatus === 'failed') return 'is-danger' // QC Failed
      if (qcStatus === 'pending' || qcStatus === 'processing') return 'is-warning' // QC Pending

      // TX file exists but no QC run (direct upload/assignment)
      return 'is-info' // Assigned (No QC)
    },

    /**
     * Get TX File status label for tag display
     * Uses same logic as EditEpisode for consistency
     */
    getTxFileStatusLabel() {
      // Primary question: Is there a TX file assigned?
      const hasTxFile = this.item.storagePath
      const qcStatus = this.item.qcStatus
      const stagingStatus = this.item.smbStagingStatus
      const approved = this.item.approvedForPlayout

      // 1. NO TX FILE
      if (!hasTxFile) {
        return 'No TX File'
      }

      // 2. Already on the playout share — strongest state
      if (stagingStatus === 'staged') return 'Staged for Playout'
      if (stagingStatus === 'staging') return 'Staging in Progress'
      if (stagingStatus === 'pending') return 'Staging Queued'
      if (stagingStatus === 'failed') return 'Staging Failed'

      // 3. Approved but not yet staged (waiting on stager pickup)
      if (approved) return 'Approved for Playout'

      // 4. TX FILE EXISTS - check QC status
      if (qcStatus === 'passed') return 'TX Ready'
      if (qcStatus === 'passed_with_warnings') return 'TX Ready*'
      if (qcStatus === 'overridden') return 'QC Overridden'
      if (qcStatus === 'failed') return 'QC Failed'
      if (qcStatus === 'processing') return 'QC Running...'
      if (qcStatus === 'pending') return 'QC Pending'

      // TX file exists but no QC run (direct upload/assignment)
      return 'TX Assigned'
    },

    /**
     * Approve-for-playout toggle handler. Saves the change immediately
     * so it survives without needing a full form save. The backend
     * captures who/when via req.user.
     */
    async onApprovedForPlayoutToggle (newValue) {
      if (!this.item.id) return // Can only save existing media
      try {
        await MediaApi.update({ ...this.item, mediaId: this.item.id })
        if (newValue) {
          this.$buefy.toast.open({
            message: 'Approved for playout. Stager will copy to Cinegy on next cycle.',
            type: 'is-success',
            duration: 4000
          })
        } else {
          this.$buefy.toast.open({
            message: 'Approval removed.',
            type: 'is-warning',
            duration: 3000
          })
        }
        // Reload to pick up server-stamped approved_at / approved_by
        await this.setData()
      } catch (error) {
        // Revert local state on save failure
        this.item.approvedForPlayout = !newValue
        this.$buefy.toast.open({
          message: 'Failed to update approval. Please try again.',
          type: 'is-danger',
          duration: 5000
        })
      }
    },

    /**
     * Format an ISO timestamp for the approval audit line.
     */
    formatApprovalDate (iso) {
      if (!iso) return ''
      try {
        const d = new Date(iso)
        return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.tx-status-display {
  padding: 8px 0;
}
</style>
